import { render } from "./DashboardMonitoreo.vue?vue&type=template&id=23bd2172&scoped=true"
import script from "./DashboardMonitoreo.vue?vue&type=script&lang=js"
export * from "./DashboardMonitoreo.vue?vue&type=script&lang=js"

import "./DashboardMonitoreo.vue?vue&type=style&index=0&id=23bd2172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd2172"]])

export default __exports__